'use client';

import { useState } from 'react';
import HeroSection from './HeroSection';
import LocationHighlights from './LocationHighlights';
import ApartmentPreview from './ApartmentPreview';
import AmenitiesShowcase from './AmenitiesShowcase';
import GuestTestimonials from './GuestTestimonials';
import BookingWidget from './BookingWidget';
import CTASection from './CTASection';
import Footer from './Footer';

export default function HomepageInteractive() {
  const [isBookingWidgetOpen, setIsBookingWidgetOpen] = useState(false);

  const handleBookingClick = () => {
    setIsBookingWidgetOpen(true);
  };

  const handleCloseBooking = () => {
    setIsBookingWidgetOpen(false);
  };

  return (
    <>
      <HeroSection onBookingClick={handleBookingClick} />
      <LocationHighlights />
      <ApartmentPreview />
      <AmenitiesShowcase />
      <GuestTestimonials />
      <CTASection />
      <Footer />
      <BookingWidget isOpen={isBookingWidgetOpen} onClose={handleCloseBooking} />
    </>
  );
}